export default __webpack_public_path__ + "static/empty-bag-thumb-2-b72a2048fb4e2a791dbeeedf566419ab.webp";